import { render, staticRenderFns } from "./CreateSidebar.vue?vue&type=template&id=8c328558&scoped=true&"
import script from "./CreateSidebar.vue?vue&type=script&lang=js&"
export * from "./CreateSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CreateSidebar.vue?vue&type=style&index=0&id=8c328558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c328558",
  null
  
)

export default component.exports